import { memo } from 'react';
import { TooltipPosition } from '@ds/elements/Tooltip/Tooltip.types';
import { Tooltip } from '@ds';
import classNames from 'classnames';
import { getFormattedDate, UserDateFormat } from 'src/utils/formatters/formatDate';
import { useThemeStore } from 'src/stores/ThemeStore';
import styles from './FieldWithTooltip.module.scss';

/**
 * Component for displaying a field with a label, tooltip, and value.
 */
const FieldWithTooltip = ({
  label,
  iconClass,
  value,
  tooltipContent,
  tooltipPosition = TooltipPosition.Left,
  isDate = false,
}: {
  label: string;
  iconClass: string;
  value: string | number | undefined | null;
  tooltipContent: string | React.ReactNode;
  tooltipPosition?: TooltipPosition;
  isDate?: boolean;
}) => {
  const { isDeloitteTheme } = useThemeStore();

  if (!value) return null; // Avoid rendering empty fields

  return (
    <div className={styles['document-field']}>
      <div className={styles['field-label']}>
        <p>{label}</p>
        <div className={classNames(styles[isDeloitteTheme ? 'info-icon-deloitte' : 'info-icon'], iconClass)}></div>
        <Tooltip
          className={styles['document-info-tooltip']}
          target={`.${iconClass}`}
          content={tooltipContent}
          position={tooltipPosition}
        />
      </div>
      <span className={styles['field-info']}>
        {isDate ? getFormattedDate(value as string, UserDateFormat.get()) : value}
      </span>
    </div>
  );
};

export default memo(FieldWithTooltip);
